/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Claim } from './Claim';
import {
    ClaimFromJSON,
    ClaimFromJSONTyped,
    ClaimToJSON,
    ClaimToJSONTyped,
} from './Claim';

/**
 * 
 * @export
 * @interface ClaimsIdentity
 */
export interface ClaimsIdentity {
    /**
     * 
     * @type {string}
     * @memberof ClaimsIdentity
     */
    readonly authenticationType?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimsIdentity
     */
    readonly isAuthenticated?: boolean;
    /**
     * 
     * @type {ClaimsIdentity}
     * @memberof ClaimsIdentity
     */
    actor?: ClaimsIdentity;
    /**
     * 
     * @type {any}
     * @memberof ClaimsIdentity
     */
    bootstrapContext?: any | null;
    /**
     * 
     * @type {Array<Claim>}
     * @memberof ClaimsIdentity
     */
    readonly claims?: Array<Claim> | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimsIdentity
     */
    label?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimsIdentity
     */
    readonly name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimsIdentity
     */
    readonly nameClaimType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimsIdentity
     */
    readonly roleClaimType?: string | null;
}

/**
 * Check if a given object implements the ClaimsIdentity interface.
 */
export function instanceOfClaimsIdentity(value: object): value is ClaimsIdentity {
    return true;
}

export function ClaimsIdentityFromJSON(json: any): ClaimsIdentity {
    return ClaimsIdentityFromJSONTyped(json, false);
}

export function ClaimsIdentityFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimsIdentity {
    if (json == null) {
        return json;
    }
    return {
        
        'authenticationType': json['authenticationType'] == null ? undefined : json['authenticationType'],
        'isAuthenticated': json['isAuthenticated'] == null ? undefined : json['isAuthenticated'],
        'actor': json['actor'] == null ? undefined : ClaimsIdentityFromJSON(json['actor']),
        'bootstrapContext': json['bootstrapContext'] == null ? undefined : json['bootstrapContext'],
        'claims': json['claims'] == null ? undefined : ((json['claims'] as Array<any>).map(ClaimFromJSON)),
        'label': json['label'] == null ? undefined : json['label'],
        'name': json['name'] == null ? undefined : json['name'],
        'nameClaimType': json['nameClaimType'] == null ? undefined : json['nameClaimType'],
        'roleClaimType': json['roleClaimType'] == null ? undefined : json['roleClaimType'],
    };
}

export function ClaimsIdentityToJSON(json: any): ClaimsIdentity {
    return ClaimsIdentityToJSONTyped(json, false);
}

export function ClaimsIdentityToJSONTyped(value?: Omit<ClaimsIdentity, 'authenticationType'|'isAuthenticated'|'claims'|'name'|'nameClaimType'|'roleClaimType'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'actor': ClaimsIdentityToJSON(value['actor']),
        'bootstrapContext': value['bootstrapContext'],
        'label': value['label'],
    };
}

